module.exports = __webpack_public_path__ + "img/hud_main_trans_circle.8e2f161a.png";